import type { AnyAction } from 'redux';
import type { User } from 'types';

import { AUTH_ACTION_TYPES } from 'redux/actions/auth/authActionTypes';

export type LoginInitialState = {
  user: User | Record<string, never>;
};

const initialState: LoginInitialState = {
  user: {},
};

export const login = (state = initialState, action: AnyAction): LoginInitialState => {
  switch (action.type) {
    case AUTH_ACTION_TYPES.SIGNIN: {
      return {
        ...state,
        user: action.user,
      };
    }
    case AUTH_ACTION_TYPES.RESET_AUTH_STATE:
      return initialState;
    default: {
      return state;
    }
  }
};
